import type { SerializedError } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import type { Problem } from './generated';

function isProblem(value: unknown): value is Problem {
  return typeof value === 'object' && value !== null && typeof (value as Problem).title === 'string'
    && typeof (value as Problem).status === 'number';
}

/** HTTP status of a failed request, if the server answered. */
export function statusOf(error: FetchBaseQueryError | SerializedError | undefined): number | undefined {
  return error !== undefined && 'status' in error && typeof error.status === 'number' ? error.status : undefined;
}

/** A human-readable message for any RTK Query error, preferring the server's RFC 9457 detail. */
export function messageOf(error: FetchBaseQueryError | SerializedError): string {
  if ('status' in error) {
    if (isProblem(error.data)) {
      return error.data.detail ?? error.data.title;
    }
    if (typeof error.status === 'number') {
      return `The server answered with status ${error.status}.`;
    }
    return error.status === 'FETCH_ERROR' ? 'The server could not be reached.' : 'The request failed.';
  }
  return error.message ?? 'Something went wrong.';
}
